exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cell[data-v-18e5071e] {\n  height: 1rem;\n  padding: 0.6rem 0.5rem;\n}\n.cell .title[data-v-18e5071e] {\n  width: 15rem;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.cell .title p[data-v-18e5071e] {\n  display: inline;\n}\n.cell .title img[data-v-18e5071e] {\n  height: 1rem;\n  width: auto;\n  margin-right: 0.5rem;\n}", ""]);

// exports
